import { proxyBE } from "./common";

export const enrollmentEvaluationServiceIndire = {
  
  positionsList(bandoId) {
    return proxyBE.get(`/admin-tfa-indire/list-positions/${bandoId}`);
  },

  checkPaymentStatus(company, bandoedition, aa) {
    return proxyBE.get(`bandiaction/enrollmentEvaluation/check-payment-status-bulk/${company}/${bandoedition}/${aa}`);
  },

  analyze(company, bandoedition, aa) {
    return proxyBE.get(`bandiaction/enrollmentEvaluation/analyze-bulk/${company}/${bandoedition}/${aa}`);
  },

  exportPositions(company, bandoedition, aa) {
    return proxyBE.get(`/bandiaction/enrollmentEvaluation/export-positions-bulk/${company}/${bandoedition}/${aa}`, {
      responseType: "blob",
    });
  },

  exportEnrolled(aa, company) {
    return proxyBE.get(`/admin-tfa-indire/export-enrolled-bulk/${aa}/${company}`, { responseType: "blob" });
  },

  closeEnrollmentBando(company, bandoedition, aa) {
    return proxyBE.get(`/bandiaction/enrollmentEvaluation/close-enrollment-bando-bulk/${company}/${bandoedition}/${aa}`);
  },

  createPositions(company, bandoedition, aa) {
    return proxyBE.get(`/bandiaction/enrollmentEvaluation/create-positions-bulk/${company}/${bandoedition}/${aa}`);
  },

  bandoEvaluationInfoList(bandoedition, aa, company) {
    return proxyBE.get(`/admin-tfa-indire/list/${bandoedition}/${aa}/${company}`);
  },

  rebuildPDF(bandoId) {
    return proxyBE.post(`/admin-tfa-indire/enrollmentEvaluation/rebuild-pdf/`, {
      bandoId,
    });
  },

  admitEvaluation(evalId) {
    return proxyBE.post(`/bandiaction/enrollmentEvaluation/admit-evaluation/`, {
      evalId,
    });
  },

  rejectEvaluation(evalId) {
    return proxyBE.post(`/bandiaction/enrollmentEvaluation/reject-evaluation/`, { evalId });
  },

  confirmBandoEnrollment(payload) {
    return proxyBE.put("enrollmentEvaluation/confirmBando", payload);
  },

  rejectBandoEnrollment(payload) {
    return proxyBE.post("enrollmentEvaluation/rejectBando", payload);
  },

  myUserEnrollmentEvaluations(bandoedition) {
    return proxyBE.get(`enrollmentEvaluation/list/${bandoedition}`);
  },

  bandoEvaluationLogList(bandoedition, aa, company) {
    return proxyBE.get(`/bandiaction/bandoEvaluationLog/list/${bandoedition}/${aa}/${company}`);
  },
};
